import { useEffect, useState } from 'react';
import { API } from '../../config/apiBase';

/**
 * A aba "Destaques" ordena por curtidas (`sort=hot` no backend). Em 2026-09-12
 * nenhuma oferta tinha curtida, e o campo nem existe na maioria dos documentos:
 * a aba mostrava uma ordem arbitrária com nome de ranking.
 *
 * Regra: o ranking por curtidas só aparece quando ele preenche uma fileira
 * inteira da grade no maior layout (5 colunas em `xl`) só com ofertas curtidas.
 * Com menos que isso, a primeira fileira já misturaria ofertas sem sinal nenhum.
 * Não há ranking substituto inventado: a aba simplesmente não aparece, e as
 * ordens reais (recentes, desconto, preço) continuam.
 */
export const MINIMO_OFERTAS_CURTIDAS = 5;

export function temSinalDeCurtidas(deals) {
    if (!Array.isArray(deals) || deals.length < MINIMO_OFERTAS_CURTIDAS) return false;
    return deals.slice(0, MINIMO_OFERTAS_CURTIDAS).every((d) => Number(d && d.likes) > 0);
}

/** null enquanto não sabe; true/false depois da resposta real. Erro conta como sem sinal. */
export function useSinalDeCurtidas() {
    const [sinal, setSinal] = useState(null);
    useEffect(() => {
        let ativo = true;
        fetch(`${API}/produtos?sort=hot&limit=${MINIMO_OFERTAS_CURTIDAS}`)
            .then((r) => r.json())
            .then((d) => { if (ativo) setSinal(temSinalDeCurtidas(d && d.deals)); })
            .catch(() => { if (ativo) setSinal(false); });
        return () => { ativo = false; };
    }, []);
    return sinal;
}
